import AppConfig from "./AppConfig";
export function addUtmParam(url, component, serviceType) {
    if (component === void 0) { component = 'header'; }
    if (url && url !== '') {
        try {
            var getUrl = new URL(url);
            var params = getUrl.searchParams;
            switch (serviceType) {
                case AppConfig.APERZA_SEARCH:
                    if (!params.has('utm_source')) {
                        params.append('utm_source', "".concat(component, "_portal"));
                    }
                    if (!params.has('utm_medium')) {
                        params.append('utm_medium', 'app');
                    }
                    break;
                case AppConfig.APERZA_TV:
                    if (!params.has('utm_source')) {
                        params.append('utm_source', "".concat(component, "_tv"));
                    }
                    if (!params.has('utm_medium')) {
                        params.append('utm_medium', 'app');
                    }
                    break;
                case AppConfig.APERZA_CATALOG:
                    if (!params.has('utm_source')) {
                        params.append('utm_source', "".concat(component, "_catalog"));
                    }
                    if (!params.has('utm_medium')) {
                        params.append('utm_medium', 'app');
                    }
                    break;
                case AppConfig.APERZA_NEWS:
                    if (!params.has('utm_source')) {
                        params.append('utm_source', "".concat(component, "_news"));
                    }
                    if (!params.has('utm_medium')) {
                        params.append('utm_medium', 'app');
                    }
                    break;
                case AppConfig.APERZA_EC:
                    if (!params.has('utm_source')) {
                        params.append('utm_source', "".concat(component, "_ec"));
                    }
                    if (!params.has('utm_medium')) {
                        params.append('utm_medium', 'app');
                    }
                    break;
                default:
                    break;
            }
            return getUrl.toString();
        }
        catch (e) {
            return url;
        }
    }
    return url;
}
